// Minimal RRULE support: FREQ + INTERVAL + UNTIL is all the Event form exposes.
// Kendo v4 has no standalone recurrence editor export, so we compose the string ourselves.

export const FREQUENCIES = ['Does not repeat', 'Daily', 'Weekly', 'Monthly', 'Yearly'];

const NONE = FREQUENCIES[0];

const toUntilString = (date) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}`
    + `T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}Z`;
};

const fromUntilString = (value) => {
  const match = /^(\d{4})(\d{2})(\d{2})(?:T(\d{2})(\d{2})(\d{2})Z?)?$/.exec(value);
  if (!match) return null;
  const [, y, mo, d, h = '0', mi = '0', s = '0'] = match;
  return new Date(Date.UTC(+y, +mo - 1, +d, +h, +mi, +s));
};

export const parseRecurrenceRule = (rule) => {
  if (!rule) return { frequency: NONE, interval: 1, until: null };

  const parts = rule.split(';').reduce((acc, pair) => {
    const [key, value] = pair.split('=');
    if (key) acc[key.toUpperCase()] = value;
    return acc;
  }, {});

  const freq = (parts.FREQ || '').toUpperCase();
  const frequency = FREQUENCIES.find(f => f.toUpperCase() === freq) || NONE;

  return {
    frequency,
    interval: parts.INTERVAL ? Math.max(1, parseInt(parts.INTERVAL, 10) || 1) : 1,
    until: parts.UNTIL ? fromUntilString(parts.UNTIL) : null,
  };
};

export const buildRecurrenceRule = ({ frequency, interval, until }) => {
  if (!frequency || frequency === NONE) return null;

  const segments = [`FREQ=${frequency.toUpperCase()}`];
  if (interval && interval > 1) segments.push(`INTERVAL=${interval}`);
  if (until) segments.push(`UNTIL=${toUntilString(new Date(until))}`);

  return segments.join(';');
};
